const formatAnswers = (
	answers?: AdminObservationAnswer[]
): IObservationAnswer[] => {
	if (!answers) return [];

	const formattedAnswers = answers.map((answer) => {
		return {
			id: answer.order,

			uuid: String(answer.order),

			name: answer.name,

			order: answer.order,
		};
	});

	return formattedAnswers;
};

export default formatAnswers;
